import { Environment, Network, RecordSource, Store } from 'relay-runtime';

import { fetchQuery, setupSubscription } from './graphqlFunctions.js';

const network = Network.create(fetchQuery, setupSubscription);

const environment = new Environment({
  network: network,
  store: new Store(new RecordSource()),
});

export default environment;
